var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b;
import { jsx as _jsx } from "react/jsx-runtime";
import { BacteriaIcon, ChickenIcon, CowIcon, DogIcon, GutIcon, LeafIcon, NoPipetIcon, PawHeartIcon, PharmacyIcon, SweetPotatoIcon, } from '@marketing-icons';
import { clsx } from 'clsx';
export var RTBIconName;
(function (RTBIconName) {
    RTBIconName["COW"] = "cow";
    RTBIconName["DOG"] = "dog";
    RTBIconName["PAW_HEART"] = "pawHeart";
    RTBIconName["NO_PIPET"] = "noPipet";
    RTBIconName["LEAF"] = "leaf";
    RTBIconName["CHICKEN"] = "chicken";
    RTBIconName["SWEET_POTATO"] = "sweetPotato";
    RTBIconName["GUT"] = "gut";
    RTBIconName["BACTERIA"] = "bacteria";
    RTBIconName["PHARMACY"] = "pharmacy";
})(RTBIconName || (RTBIconName = {}));
var iconMap = (_a = {},
    _a[RTBIconName.COW] = CowIcon,
    _a[RTBIconName.DOG] = DogIcon,
    _a[RTBIconName.PAW_HEART] = PawHeartIcon,
    _a[RTBIconName.NO_PIPET] = NoPipetIcon,
    _a[RTBIconName.LEAF] = LeafIcon,
    _a[RTBIconName.CHICKEN] = ChickenIcon,
    _a[RTBIconName.SWEET_POTATO] = SweetPotatoIcon,
    _a[RTBIconName.GUT] = GutIcon,
    _a[RTBIconName.BACTERIA] = BacteriaIcon,
    _a[RTBIconName.PHARMACY] = PharmacyIcon,
    _a);
export var RTBColor;
(function (RTBColor) {
    RTBColor["BLUE"] = "blue";
    RTBColor["ORANGE"] = "orange";
    RTBColor["PINK"] = "pink";
    RTBColor["SQUASH"] = "squash";
    RTBColor["BACON"] = "bacon";
})(RTBColor || (RTBColor = {}));
var backgroundColorMap = (_b = {},
    _b[RTBColor.BACON] = 'bg-surface-bacon',
    _b[RTBColor.BLUE] = 'bg-deco-blue',
    _b[RTBColor.ORANGE] = 'bg-state-hover-primary-account',
    _b[RTBColor.PINK] = 'bg-deco-pink',
    _b[RTBColor.SQUASH] = 'bg-action-surface-primary',
    _b);
function Icons(_a) {
    var name = _a.name, backgroundColor = _a.backgroundColor, _b = _a.size, size = _b === void 0 ? 'large' : _b, _c = _a.theme, theme = _c === void 0 ? 'light' : _c, _d = _a.className, className = _d === void 0 ? '' : _d;
    var Icon = iconMap[name];
    var backgroundColorStyle = backgroundColorMap[backgroundColor];
    var sizing = size === 'large' ? 'size-[132px]' : 'size-24';
    var textColor = theme === 'dark' ? 'text-text-white' : 'text-text-black';
    return (_jsx("div", __assign({ className: clsx('flex justify-center items-center rounded-full border-2', theme === 'dark' ? 'border-text-white' : 'border-border-shoe', backgroundColorStyle, textColor, sizing, className) }, { children: _jsx(Icon, { "aria-hidden": "true", className: clsx(size === 'large' ? 'size-[84px]' : 'size-16', theme === 'dark' ? 'text-text-white' : 'text-text-body') }) })));
}
export default Icons;
